import Slider from "react-slick";
import { SlidePhoto } from "./SlidePhoto";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        previewContainer: {
            marginBottom: theme.spacing(5),
            background: "#5e5e5e",
            width: "296px",
            height: "296px",
            marginLeft: "auto",
            marginRight: "auto",
            overflow: "visible",  
            position: "relative", 
            paddingBottom: theme.spacing(4),
        },
        /*slickList: {
            overflow: "hidden",
        }, */
    })
);

export const PreviewPhotos = (props: {
    photos: any;
    idProperty: string;
    isUpdating: boolean;
    onDeletePhoto?: (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => void;
}) => {
  const classes = useStyles();  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    centerMode: false, // Ensure that slides align correctly
  };
  const { t } = useTranslation<'common'>();
  const removeThePhoto = (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => {
        if (props.onDeletePhoto)
                    {
            // Confirm deletion with user
            if (window.confirm(t("label.delete-file"))) {
                props.onDeletePhoto(idProperty, idPhoto, photoName);
            }
            }
    };

  return (
        <div className={classes.previewContainer}>
            <Slider {...settings} >
                {props.photos.map((photo: any, index: any) => (
                    <SlidePhoto
                        key={index}
                        filename={photo.filename}
                        fileURL={photo.url ?? photo.fileURL}
                        isUpdating={props.isUpdating}
                        idProperty={props.idProperty}
                        idPhoto={photo.id}
                        removeThePhoto={removeThePhoto}
                    />
                ))}
            </Slider>
        </div>
    );
};
